import { Badge, SvgIcon, SvgIconProps, Theme } from '@mui/material';
import { forwardRef } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { SxProps } from '@mui/system';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

export interface FontAwesomeSvgIconProps extends SvgIconProps {
    icon: IconDefinition;
}

type FontAwesomeSvgProps = SvgIconProps;

export const MediaUploadIcon = ({
    sx,
    ...rest
}: {
    sx?: SxProps;
}): JSX.Element => {
    return (
        <SvgIcon
            width="23"
            height="18"
            viewBox="0 0 23 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={sx}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.63281 4.61719C10.0547 4.01953 11.0391 4.01953 11.4258 4.61719L12.2758 5.90661C11.9634 6.10586 11.6679 6.32922 11.3919 6.57405L10.5117 5.25L7.55859 9.82031C7.45312 9.96094 7.27734 10.0664 7.10156 10.0664C6.92578 10.1016 6.75 9.99609 6.64453 9.82031L5.58984 8.37891L3.375 11.4375H9.04503C9.03848 11.5617 9.03516 11.6867 9.03516 11.8125C9.03516 12.0659 9.04862 12.3161 9.07486 12.5625H3.33984C2.95312 12.5625 2.56641 12.3516 2.39062 12C2.21484 11.6133 2.25 11.1914 2.46094 10.875L4.74609 7.71094C5.13281 7.14844 6.08203 7.14844 6.50391 7.71094L7.06641 8.51953L9.63281 4.61719ZM9.70879 14.8125H2.28516C1.65234 14.8125 1.16016 14.3203 1.16016 13.6875V2.4375C1.16016 1.83984 1.65234 1.3125 2.28516 1.3125H15.7852C16.3828 1.3125 16.9102 1.83984 16.9102 2.4375V4.86666C17.2834 4.91319 17.6474 4.98911 18 5.09202V2.4375C18 1.20703 17.0156 0.1875 15.75 0.1875H2.25C1.01953 0.1875 0 1.20703 0 2.4375V13.6875C0 14.9531 1.01953 15.9375 2.25 15.9375H10.3791C10.1222 15.5859 9.89738 15.2095 9.70879 14.8125ZM6.78516 4.125C6.78516 5.07422 6.01172 5.8125 5.09766 5.8125C4.14844 5.8125 3.41016 5.07422 3.41016 4.125C3.41016 3.21094 4.14844 2.4375 5.09766 2.4375C6.01172 2.4375 6.78516 3.21094 6.78516 4.125ZM5.625 4.125C5.625 3.84375 5.37891 3.5625 5.09766 3.5625C4.78125 3.5625 4.53516 3.84375 4.53516 4.125C4.53516 4.44141 4.78125 4.6875 5.09766 4.6875C5.37891 4.6875 5.625 4.44141 5.625 4.125Z"
                fill="black"
                fillOpacity="0.54"
            />
            <path
                d="M16.4336 8.625C16.3398 8.50781 16.1758 8.4375 16.0352 8.4375C15.8711 8.4375 15.707 8.50781 15.6133 8.625L13.1758 11.25C12.9648 11.4844 12.9648 11.8359 13.1992 12.0469C13.4336 12.2578 13.7852 12.2578 13.9961 12.0234L15.4727 10.4531V14.4375C15.4727 14.7656 15.707 15 16.0352 15C16.3398 15 16.5977 14.7656 16.5977 14.4375V10.4531L18.0508 12.0234C18.2617 12.2578 18.6133 12.2578 18.8477 12.0469C19.082 11.8359 19.082 11.4844 18.8711 11.25L16.4336 8.625ZM16.0352 5.8125C12.707 5.8125 10.0352 8.50781 10.0352 11.8125C10.0352 15.1406 12.707 17.8125 16.0352 17.8125C19.3398 17.8125 22.0352 15.1406 22.0352 11.8125C22.0352 8.50781 19.3398 5.8125 16.0352 5.8125ZM16.0352 16.6875C13.3398 16.6875 11.1602 14.5078 11.1602 11.8125C11.1602 9.14062 13.3398 6.9375 16.0352 6.9375C18.707 6.9375 20.9102 9.14062 20.9102 11.8125C20.9102 14.5078 18.707 16.6875 16.0352 16.6875Z"
                fill="black"
                fillOpacity="0.54"
            />
        </SvgIcon>
    );
};

export const FASolidStarIcon = forwardRef<SVGSVGElement, FontAwesomeSvgProps>(
    // eslint-disable-next-line react/prop-types
    ({ sx }, ref) => {
        return (
            <SvgIcon ref={ref} sx={sx} viewBox="0 0 576 512">
                <path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z" />
            </SvgIcon>
        );
    }
);
FASolidStarIcon.displayName = 'FASolidStarIcon';

export const FASolidHalfStarIcon = forwardRef<
    SVGSVGElement,
    { sx?: SxProps<Theme>; secondaryColor?: string }
>(
    // eslint-disable-next-line react/prop-types
    ({ sx, secondaryColor }, ref) => {
        return (
            <SvgIcon ref={ref} sx={sx} viewBox="0 0 576 512">
                <path
                    style={
                        secondaryColor
                            ? { color: secondaryColor }
                            : { opacity: 0.4 }
                    }
                    d="M287.1 .0049C288 .0049 287.1 .0049 287.1 .0049c11.39 0 22.87 5.894 28.75 17.8l65.43 132.4l146.4 21.29c26.27 3.797 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5C468.1 495.3 452.4 512 433.8 512c-4.932 0-10.01-1.172-14.88-3.75L288 439.6L287.1 .0049z"
                />
                <path d="M288 439.6l-130.9 68.7C152.2 510.8 147.1 512 142.2 512c-18.59 0-35.17-16.66-31.61-37.45l25.04-145.5L29.72 226.1C10.68 207.6 21.2 175.3 47.47 171.5l146.4-21.29l65.43-132.4c5.883-11.91 17.33-17.8 28.73-17.8c.0234 0-.0234 0 0 0L288 439.6z" />
            </SvgIcon>
        );
    }
);
FASolidHalfStarIcon.displayName = 'FASolidHalfStarIcon';

export const Icon = forwardRef<SVGSVGElement, FontAwesomeSvgIconProps>(
    // eslint-disable-next-line react/prop-types
    ({ sx, icon, ...rest }, ref) => {
        const {
            // eslint-disable-next-line react/prop-types
            icon: [width, height, , , svgPathData],
        } = icon;

        return (
            <SvgIcon
                sx={sx}
                ref={ref}
                {...rest}
                viewBox={`0 0 ${width} ${height}`}
            >
                {typeof svgPathData === 'string' ? (
                    <path d={svgPathData} />
                ) : (
                    /**
                     * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
                     * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
                     * of a duotone icon. 40% is the default opacity.
                     *
                     * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
                     */
                    svgPathData.map((d: string, i: number) => (
                        <path
                            key={i}
                            style={{ opacity: i === 0 ? 0.4 : 1 }}
                            d={d}
                        />
                    ))
                )}
            </SvgIcon>
        );
    }
);
Icon.displayName = 'Icon';

export const NavIcons: Record<string, JSX.Element> = {
    Insights: (
        <SvgIcon
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M8.4375 0.875C9.35156 0.875 10.125 1.64844 10.125 2.5625V14.9375C10.125 15.8867 9.35156 16.625 8.4375 16.625H7.3125C6.36328 16.625 5.625 15.8867 5.625 14.9375V2.5625C5.625 1.64844 6.36328 0.875 7.3125 0.875H8.4375ZM8.4375 2.5625H7.3125V14.9375H8.4375V2.5625ZM2.8125 7.625C3.72656 7.625 4.5 8.39844 4.5 9.3125V14.9375C4.5 15.8867 3.72656 16.625 2.8125 16.625H1.6875C0.738281 16.625 0 15.8867 0 14.9375V9.3125C0 8.39844 0.738281 7.625 1.6875 7.625H2.8125ZM2.8125 9.3125H1.6875V14.9375H2.8125V9.3125ZM11.25 4.8125C11.25 3.89844 11.9883 3.125 12.9375 3.125H14.0625C14.9766 3.125 15.75 3.89844 15.75 4.8125V14.9375C15.75 15.8867 14.9766 16.625 14.0625 16.625H12.9375C11.9883 16.625 11.25 15.8867 11.25 14.9375V4.8125ZM12.9375 14.9375H14.0625V4.8125H12.9375V14.9375Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Jobs: (
        <SvgIcon
            width="22"
            height="19"
            viewBox="0 0 22 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M20.9336 8.83594C21.2852 9.15234 21.3203 9.67969 21.0391 10.0312C20.7227 10.3828 20.1953 10.418 19.8438 10.1367L19 9.39844V15.9375C19 17.5195 17.7344 18.75 16.1875 18.75H6.0625C4.48047 18.75 3.25 17.5195 3.25 15.9375V9.39844L2.37109 10.1367C2.01953 10.418 1.49219 10.3828 1.17578 10.0312C0.894531 9.67969 0.929688 9.15234 1.28125 8.83594L10.5625 0.960938C10.8789 0.714844 11.3359 0.714844 11.6523 0.960938L20.9336 8.83594ZM6.0625 17.0625H9.05078L7.99609 15.375C7.85547 15.1289 7.89062 14.8125 8.13672 14.6367L11.125 12.2812L9.05078 9.60938C8.66406 9.08203 9.33203 8.41406 9.85938 8.80078L13.9023 11.8594C14.1836 12.0703 14.1836 12.4922 13.9023 12.7383L11.125 14.9531L12.4258 17.0625H16.1875C16.7852 17.0625 17.3125 16.5703 17.3125 15.9375V7.95703L11.125 2.71875L4.9375 7.95703V15.9375C4.9375 16.5703 5.42969 17.0625 6.0625 17.0625Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Reviews: (
        <SvgIcon
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M10.0898 0.75C10.4414 0.75 10.7227 0.960938 10.8633 1.24219L13.2891 6.19922L18.668 7.00781C18.9844 7.04297 19.2305 7.28906 19.3359 7.57031C19.4414 7.88672 19.3711 8.20312 19.125 8.44922L15.2227 12.3164L16.1367 17.7656C16.207 18.082 16.0664 18.4336 15.8203 18.6094C15.5391 18.7852 15.1875 18.8203 14.9062 18.6797L10.0898 16.0781L5.27344 18.6797C4.99219 18.8203 4.67578 18.7852 4.39453 18.6094C4.14844 18.4336 4.00781 18.082 4.04297 17.7656L4.99219 12.3164L1.08984 8.44922C0.84375 8.20312 0.773438 7.88672 0.878906 7.57031C0.984375 7.28906 1.23047 7.04297 1.54688 7.00781L6.92578 6.19922L9.35156 1.24219C9.49219 0.960938 9.77344 0.75 10.0898 0.75ZM10.0898 3.52734L8.26172 7.35938C8.12109 7.60547 7.91016 7.78125 7.62891 7.81641L3.44531 8.41406L6.46875 11.4023C6.67969 11.6133 6.75 11.8945 6.71484 12.1758L6.01172 16.3594L9.70312 14.3906C9.94922 14.25 10.2656 14.25 10.5117 14.3906L14.2031 16.3594L13.5 12.1758C13.4297 11.8945 13.5352 11.6133 13.7461 11.4023L16.7344 8.41406L12.5859 7.81641C12.3047 7.78125 12.0586 7.60547 11.9531 7.35938L10.0898 3.52734Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Media: (
        <SvgIcon
            width="23"
            height="19"
            viewBox="0 0 23 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M16.8125 16.5C16.8125 16.8164 16.5312 17.0625 16.25 17.0625H14.5625V14.25H12.875V17.0625H6.125V5.25H2.75C1.48438 5.25 0.5 6.26953 0.5 7.5V16.5C0.5 17.7656 1.48438 18.75 2.75 18.75H16.25C17.4805 18.75 18.5 17.7656 18.5 16.5V14.25H16.8125V16.5ZM4.4375 17.0625H2.75C2.43359 17.0625 2.1875 16.8164 2.1875 16.5V14.8125H4.4375V17.0625ZM4.4375 13.125H2.1875V10.875H4.4375V13.125ZM4.4375 9.1875H2.1875V7.5C2.1875 7.21875 2.43359 6.9375 2.75 6.9375H4.4375V9.1875ZM20.75 0.75H9.5C8.23438 0.75 7.25 1.76953 7.25 3V10.875C7.25 12.1406 8.23438 13.125 9.5 13.125H20.75C21.9805 13.125 23 12.1406 23 10.875V3C23 1.76953 21.9805 0.75 20.75 0.75ZM21.3125 10.875C21.3125 11.1914 21.0312 11.4375 20.75 11.4375L16.8828 5.8125C16.7773 5.63672 16.6016 5.53125 16.4258 5.53125C16.2148 5.53125 16.0391 5.63672 15.9336 5.8125L13.7539 9.11719L12.9453 8.02734C12.8398 7.88672 12.6992 7.78125 12.4883 7.78125C12.2773 7.78125 12.1367 7.88672 12.0312 8.02734L9.5 11.4375C9.18359 11.4375 8.9375 11.1914 8.9375 10.875V3C8.9375 2.71875 9.18359 2.4375 9.5 2.4375H20.75C21.0312 2.4375 21.3125 2.71875 21.3125 3V10.875ZM11.1523 3.5625C10.5195 3.5625 10.0273 4.08984 10.0273 4.6875C10.0273 5.32031 10.5195 5.8125 11.1523 5.8125C11.75 5.8125 12.2773 5.32031 12.2773 4.6875C12.2773 4.08984 11.7852 3.5625 11.1523 3.5625Z"
                fill="white"
            />
        </SvgIcon>
    ),
    CalendarV2: (
        <Icon
            sx={{
                color: (theme) => theme.palette.common.white,
            }}
            icon={faCalendar}
        />
    ),
    CalendarAlertV2: (
        <Badge
            badgeContent={''}
            color={'error'}
            sx={{
                '& .MuiBadge-badge': {
                    right: (theme) => `-${theme.spacing(0.33)}`,
                    top: (theme) => theme.spacing(0.6),
                    height: '4px',
                    width: '4px',
                    minWidth: '4px',
                    minHeight: '4px',
                    padding: '4px',
                },
            }}
        >
            <Icon
                sx={{
                    color: (theme) => theme.palette.common.white,
                }}
                icon={faCalendar}
            />
        </Badge>
    ),
    Calendar: (
        <SvgIcon
            width="17"
            height="19"
            viewBox="0 0 17 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M5.84375 3H10.9062V1.59375C10.9062 1.13672 11.2578 0.75 11.75 0.75C12.207 0.75 12.5938 1.13672 12.5938 1.59375V3H14C15.2305 3 16.25 4.01953 16.25 5.25V16.5C16.25 17.7656 15.2305 18.75 14 18.75H2.75C1.48438 18.75 0.5 17.7656 0.5 16.5V5.25C0.5 4.01953 1.48438 3 2.75 3H4.15625V1.59375C4.15625 1.13672 4.50781 0.75 5 0.75C5.45703 0.75 5.84375 1.13672 5.84375 1.59375V3ZM2.1875 16.5C2.1875 16.8164 2.43359 17.0625 2.75 17.0625H14C14.2812 17.0625 14.5625 16.8164 14.5625 16.5V7.5H2.1875V16.5Z"
                fill="white"
            />
        </SvgIcon>
    ),
    CalendarAlert: (
        <SvgIcon
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M13 16.8125C13 17.4453 12.4727 17.9375 11.875 17.9375C11.2422 17.9375 10.75 17.4453 10.75 16.8125C10.75 16.2148 11.2422 15.6875 11.875 15.6875C12.4727 15.6875 13 16.2148 13 16.8125ZM12.7188 13.7188C12.7188 14.2109 12.332 14.5625 11.875 14.5625C11.3828 14.5625 11.0312 14.2109 11.0312 13.7188V11.4688C11.0312 11.0117 11.3828 10.625 11.875 10.625C12.332 10.625 12.7188 11.0117 12.7188 11.4688V13.7188ZM9.34375 5H14.4062V3.59375C14.4062 3.13672 14.7578 2.75 15.25 2.75C15.707 2.75 16.0938 3.13672 16.0938 3.59375V5H17.5C18.7305 5 19.75 6.01953 19.75 7.25V18.5C19.75 19.7656 18.7305 20.75 17.5 20.75H6.25C4.98438 20.75 4 19.7656 4 18.5V7.25C4 6.01953 4.98438 5 6.25 5H7.65625V3.59375C7.65625 3.13672 8.00781 2.75 8.5 2.75C8.95703 2.75 9.34375 3.13672 9.34375 3.59375V5ZM5.6875 18.5C5.6875 18.8164 5.93359 19.0625 6.25 19.0625H17.5C17.7812 19.0625 18.0625 18.8164 18.0625 18.5V9.5H5.6875V18.5Z"
                fill="#FF5D51"
            />
        </SvgIcon>
    ),
    Settings: (
        <SvgIcon
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ p: 1 }}
        >
            <path
                d="M6.125 9.75C6.125 7.88672 7.60156 6.375 9.5 6.375C11.3633 6.375 12.875 7.88672 12.875 9.75C12.875 11.6133 11.3633 13.125 9.5 13.125C7.60156 13.125 6.125 11.6133 6.125 9.75ZM9.5 8.0625C8.55078 8.0625 7.8125 8.83594 7.8125 9.75C7.8125 10.6992 8.55078 11.4375 9.5 11.4375C10.4141 11.4375 11.1875 10.6992 11.1875 9.75C11.1875 8.83594 10.4141 8.0625 9.5 8.0625ZM10.8008 0.75C11.5742 0.75 12.2422 1.3125 12.418 2.05078L12.6992 3.21094C13.0156 3.35156 13.2969 3.52734 13.543 3.70312L14.7031 3.35156C15.4414 3.14062 16.25 3.45703 16.6367 4.125L17.9375 6.41016C18.3242 7.07812 18.1836 7.92188 17.6211 8.44922L16.7773 9.25781C16.7773 9.43359 16.8125 9.60938 16.8125 9.75C16.8125 9.92578 16.7773 10.1016 16.7773 10.2422L17.6211 11.0859C18.1836 11.6133 18.3242 12.457 17.9375 13.125L16.6367 15.4102C16.25 16.0781 15.4414 16.3945 14.7031 16.1836L13.543 15.832C13.2969 16.0078 13.0156 16.1836 12.6992 16.3242L12.418 17.4844C12.2422 18.2227 11.5742 18.75 10.8008 18.75H8.16406C7.39062 18.75 6.72266 18.2227 6.54688 17.4844L6.26562 16.3242C5.94922 16.1836 5.66797 16.0078 5.42188 15.832L4.26172 16.1836C3.52344 16.3945 2.71484 16.0781 2.32812 15.4102L1.02734 13.125C0.640625 12.457 0.78125 11.6133 1.34375 11.0859L2.1875 10.2422C2.1875 10.1016 2.1875 9.92578 2.1875 9.75C2.1875 9.60938 2.1875 9.43359 2.1875 9.25781L1.34375 8.44922C0.78125 7.92188 0.640625 7.07812 1.02734 6.41016L2.32812 4.125C2.71484 3.45703 3.52344 3.14062 4.26172 3.35156L5.42188 3.70312C5.66797 3.52734 5.94922 3.35156 6.26562 3.21094L6.54688 2.05078C6.72266 1.3125 7.39062 0.75 8.16406 0.75H10.8008ZM7.70703 4.40625L7.32031 4.58203C6.86328 4.75781 6.44141 5.00391 6.08984 5.28516L5.73828 5.56641L3.80469 4.96875L2.50391 7.25391L3.94531 8.625L3.91016 9.04688C3.875 9.29297 3.875 9.53906 3.875 9.75C3.875 9.99609 3.875 10.2422 3.91016 10.4883L3.94531 10.9102L2.50391 12.2812L3.80469 14.5664L5.73828 13.9688L6.08984 14.25C6.44141 14.5312 6.86328 14.7773 7.32031 14.9531L7.70703 15.1289L8.16406 17.0625H10.8008L11.2578 15.1289L11.6445 14.9531C12.1016 14.7773 12.5234 14.5312 12.875 14.25L13.2266 13.9688L15.1602 14.5664L16.4609 12.2812L15.0195 10.9102L15.0547 10.4883C15.0898 10.2422 15.125 9.99609 15.125 9.75C15.125 9.53906 15.0898 9.29297 15.0547 9.04688L15.0195 8.625L16.4609 7.25391L15.1602 4.96875L13.2266 5.56641L12.875 5.28516C12.5234 5.00391 12.1016 4.75781 11.6445 4.58203L11.2578 4.40625L10.8008 2.4375H8.16406L7.70703 4.40625Z"
                fill="white"
            />
        </SvgIcon>
    ),
};

export const BackArrow = ({ sx, ...rest }: { sx?: SxProps }): JSX.Element => (
    <SvgIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={sx}
        {...rest}
    >
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.207 12.25C21.207 12.8516 20.7344 13.3242 20.1758 13.3242H5.56641L11.2812 18.7383C11.7109 19.125 11.7109 19.8125 11.3242 20.1992C10.9375 20.6289 10.293 20.6289 9.86328 20.2422L2.30078 13.0234C2.08594 12.8086 2 12.5508 2 12.25C2 11.9922 2.08594 11.7344 2.30078 11.5195L9.86328 4.30078C10.293 3.91406 10.9375 3.91406 11.3242 4.34375C11.7109 4.73047 11.7109 5.41797 11.2812 5.80469L5.56641 11.2188H20.1758C20.7773 11.2188 21.207 11.6914 21.207 12.25Z"
                fill="#202126"
            />
        </svg>
    </SvgIcon>
);

export const GoogleIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                d="M18 9.21583C18 8.608 17.94 7.98056 17.84 7.39233H9.17755V10.8629H14.1389C13.9389 11.9805 13.2787 12.9609 12.2984 13.5883L15.2592 15.8432C16.9997 14.2549 18 11.9413 18 9.21583Z"
                fill="#4280EF"
            />
            <path
                d="M9.17754 17.9999C11.6582 17.9999 13.7388 17.196 15.2592 15.8235L12.2984 13.5882C11.4782 14.1372 10.4179 14.4509 9.17754 14.4509C6.77688 14.4509 4.75632 12.8627 4.01611 10.7451L0.975266 13.0392C2.5357 16.0783 5.69658 17.9999 9.17754 17.9999Z"
                fill="#34A353"
            />
            <path
                d="M4.01611 10.7255C3.63601 9.60791 3.63601 8.39224 4.01611 7.27462L0.975271 4.96094C-0.32509 7.50991 -0.32509 10.5099 0.975271 13.0392L4.01611 10.7255Z"
                fill="#F6B704"
            />
            <path
                d="M9.17754 3.5689C10.4779 3.54929 11.7583 4.03948 12.6985 4.92182L15.3193 2.33363C13.6588 0.804248 11.4582 -0.0192653 9.17754 0.000342207C5.69658 0.000342207 2.5357 1.92187 0.975266 4.96103L4.01611 7.27471C4.75632 5.1375 6.77688 3.5689 9.17754 3.5689Z"
                fill="#E54335"
            />
        </SvgIcon>
    );
});

export const ZapierIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <rect y="0.524658" width="24" height="24" rx="4" fill="#FF4F00" />
            <path
                d="M16.7337 14.4817C17.0386 14.6528 17.3842 14.7379 17.7336 14.7281C18.0182 14.7373 18.302 14.6914 18.5692 14.5928C18.7707 14.5201 18.9503 14.3971 19.0909 14.2354C19.2234 14.08 19.3192 13.8968 19.371 13.6993L18.4581 13.4433C18.4139 13.5701 18.3333 13.681 18.2263 13.762C18.0869 13.864 17.9153 13.912 17.7433 13.8973C17.6221 13.9067 17.5005 13.8875 17.3881 13.8414C17.2757 13.7952 17.1756 13.7234 17.096 13.6316C16.9678 13.4415 16.8974 13.2184 16.8931 12.9892H19.3903C19.3945 12.9168 19.3945 12.8443 19.3903 12.7719V12.5787C19.3956 12.2725 19.3329 11.969 19.2068 11.6899C19.0844 11.4376 18.8914 11.2261 18.6513 11.0813C18.3637 10.9271 18.0404 10.852 17.7143 10.864C17.4618 10.8469 17.2086 10.8809 16.9696 10.9639C16.7306 11.0469 16.5107 11.1772 16.3232 11.347C15.9836 11.7299 15.8099 12.232 15.8402 12.7429C15.8326 13.1021 15.9104 13.458 16.0672 13.7814C16.2125 14.0775 16.4452 14.3219 16.7337 14.4817ZM17.6998 11.6609C18.1828 11.6609 18.405 11.9218 18.4388 12.4482H16.8931C16.9075 12.2605 16.9726 12.0802 17.0815 11.9266C17.1588 11.8354 17.2575 11.7647 17.3687 11.7209C17.48 11.677 17.6003 11.6614 17.7191 11.6754L17.6998 11.6609Z"
                fill="#FFFDF9"
            />
            <path
                d="M7.42516 12.5507C7.05136 12.516 6.67836 12.6248 6.38186 12.855C6.2761 12.9573 6.19306 13.0807 6.13814 13.2172C6.08321 13.3537 6.05762 13.5002 6.06305 13.6472C6.05159 13.7972 6.07533 13.9478 6.13236 14.087C6.18938 14.2262 6.2781 14.3501 6.3915 14.449C6.63974 14.636 6.94571 14.73 7.25611 14.7147C7.4114 14.7194 7.56592 14.6909 7.70923 14.6309C7.85255 14.5709 7.98131 14.4809 8.08689 14.3669C8.20262 14.2377 8.29424 14.0889 8.35737 13.9273H8.42017L8.53128 14.6374H9.42485V12.3624C9.45107 11.9658 9.31906 11.575 9.05775 11.2756C8.89241 11.1339 8.70039 11.0267 8.49302 10.9604C8.28564 10.894 8.06709 10.8698 7.85021 10.8892C7.57081 10.8817 7.29243 10.9259 7.02908 11.0196C6.82081 11.0941 6.63703 11.2244 6.49777 11.3963C6.36687 11.5605 6.27888 11.7548 6.24176 11.9615L7.23197 12.1015C7.26629 11.9985 7.33434 11.91 7.42516 11.8504C7.54009 11.7866 7.67067 11.7565 7.80192 11.7634C7.88196 11.7565 7.96257 11.7666 8.03836 11.7933C8.11415 11.82 8.18339 11.8625 8.24145 11.918C8.33754 12.0492 8.38534 12.2096 8.37671 12.372V12.5507H7.42516ZM7.60387 13.8645C7.46105 13.8789 7.31806 13.8392 7.20299 13.7534C7.1665 13.7157 7.13789 13.671 7.11882 13.6221C7.09975 13.5732 7.09058 13.521 7.09187 13.4685C7.09078 13.4174 7.10008 13.3667 7.11917 13.3194C7.13827 13.2721 7.16679 13.2291 7.20299 13.1931C7.29122 13.1212 7.40326 13.085 7.51693 13.0917H8.37671V13.2318C8.37824 13.3187 8.35986 13.4047 8.32303 13.4834C8.28619 13.5621 8.23187 13.6314 8.16419 13.6858C8.00571 13.8127 7.80667 13.8779 7.60387 13.8694V13.8645Z"
                fill="#FFFDF9"
            />
            <path
                d="M15.3135 10.9752H14.2557V14.6365H15.3135V10.9752Z"
                fill="#FFFDF9"
            />
            <path
                d="M14.7972 10.483C14.8765 10.4856 14.9556 10.4719 15.0295 10.4428C15.1034 10.4137 15.1706 10.3699 15.2271 10.314C15.3367 10.1962 15.3957 10.0401 15.3913 9.87927C15.3954 9.71992 15.3364 9.56538 15.2271 9.44938C15.1702 9.39434 15.1028 9.35142 15.0289 9.32319C14.9551 9.29496 14.8762 9.28202 14.7972 9.28516C14.7174 9.28192 14.6378 9.29479 14.5631 9.32301C14.4884 9.35123 14.4202 9.3942 14.3625 9.44938C14.3066 9.50579 14.2627 9.57301 14.2337 9.64692C14.2046 9.72083 14.1909 9.79989 14.1934 9.87927C14.19 9.95947 14.2033 10.0395 14.2324 10.1143C14.2615 10.1891 14.3059 10.257 14.3626 10.3138C14.4194 10.3706 14.4873 10.4149 14.5621 10.4441C14.6369 10.4732 14.717 10.4865 14.7972 10.483Z"
                fill="#FFFDF9"
            />
            <path
                d="M11.1264 13.9222H11.1747C11.2049 14.0026 11.242 14.0802 11.2857 14.1541C11.3947 14.3538 11.5637 14.5143 11.7688 14.6129C11.9482 14.7042 12.1471 14.7506 12.3484 14.7482C12.547 14.7567 12.7444 14.7135 12.9213 14.6229C13.0982 14.5323 13.2487 14.3974 13.3579 14.2314C13.6205 13.7955 13.7451 13.2903 13.7153 12.7823C13.7417 12.289 13.6188 11.7992 13.3627 11.3767C13.244 11.2156 13.0867 11.0869 12.9052 11.0025C12.7237 10.918 12.524 10.8807 12.3242 10.8937C12.1671 10.8881 12.0106 10.9158 11.865 10.9749C11.7193 11.034 11.5877 11.1232 11.479 11.2367C11.3304 11.3976 11.2184 11.5887 11.1505 11.797H11.0926L10.9766 10.9903H10.0734V15.7046H11.1312L11.1264 13.9222ZM11.8992 11.8259C12.0102 11.8163 12.1219 11.8347 12.224 11.8795C12.3261 11.9242 12.4154 11.9938 12.4836 12.0819C12.6164 12.2941 12.6805 12.542 12.6672 12.792C12.6825 13.0519 12.6167 13.3101 12.4788 13.531C12.4133 13.6215 12.3255 13.6936 12.224 13.7401C12.1224 13.7867 12.0105 13.8061 11.8992 13.7966C11.7913 13.8026 11.6836 13.7824 11.5853 13.7378C11.4869 13.6933 11.4007 13.6256 11.3341 13.5406C11.185 13.335 11.1117 13.0841 11.1264 12.8306V12.763C11.1083 12.5136 11.1822 12.2661 11.3341 12.0674C11.4037 11.9869 11.4908 11.9232 11.5887 11.8814C11.6866 11.8395 11.7928 11.8206 11.8992 11.8259Z"
                fill="#FFFDF9"
            />
            <path
                d="M5.73759 13.7429H3.76688L3.73309 13.6318L5.70378 11.8736V10.9752H2.44342V11.8736H4.28854L4.33203 11.9896L2.39996 13.7429V14.6413H5.78108L5.73759 13.7429Z"
                fill="#FFFDF9"
            />
            <path
                d="M21.0142 12.763C20.9973 12.6584 21.0064 12.5513 21.0406 12.451C21.0747 12.3508 21.133 12.2604 21.2103 12.1879C21.2875 12.1155 21.3814 12.063 21.4836 12.0353C21.5859 12.0075 21.6934 12.0053 21.7966 12.0288H22.1976V10.9758H21.9657C21.8314 10.9698 21.6975 10.9955 21.575 11.0509C21.4524 11.1062 21.3447 11.1898 21.2605 11.2946C21.1518 11.4386 21.0729 11.6028 21.0286 11.7776H20.9755L20.8596 10.971H19.9564V14.6371H21.0142V12.763Z"
                fill="#FFFDF9"
            />
        </SvgIcon>
    );
});

export const JobNimbusIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="24"
            height="12"
            viewBox="0 0 24 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4462 0H0V11.4462C6.32131 11.4456 11.4456 6.32131 11.4462 0Z"
                fill="#3B5EAB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5538 0V11.4462H24C23.9995 5.12484 18.8752 0.000546296 12.5538 0Z"
                fill="#3B5EAB"
            />
        </SvgIcon>
    );
});

export const HousecallProIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="13"
            height="24"
            viewBox="0 0 13 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                d="M0 4.45328V19.9385L7.55572 24V0L0 4.45328ZM12.9231 21.7621H9.73958V19.961H11.1265L11.176 4.40826H9.73958V2.60713H12.9861L12.9231 21.7621Z"
                fill="black"
            />
        </SvgIcon>
    );
});

export const JobberIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <rect width="32" height="32" rx="8" fill="#0D2837" />
            <g clipPath="url(#clip0_4364_18233)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.3163 5.00044C23.4912 5.00044 23.6456 5.07764 23.7628 5.19391L26.8052 8.21773C26.8691 8.27275 26.9197 8.34146 26.9534 8.41876C26.987 8.49605 27.0028 8.57994 26.9996 8.66418V18.9364C26.9996 23.3945 23.3749 27.0006 18.9355 27.0006H8.66414C8.58049 26.9992 8.49795 26.9812 8.42131 26.9477C8.34467 26.9142 8.27545 26.8657 8.21768 26.8052L5.19479 23.7823C5.13097 23.7273 5.08036 23.6586 5.04671 23.5813C5.01306 23.504 4.99723 23.4201 5.0004 23.3359V13.0646C4.99947 8.60558 8.60461 4.99951 13.0431 4.99951H23.3163V5.00044ZM7.94609 23.8214V13.0636C7.94609 10.2333 10.2333 7.94613 13.0627 7.9266H20.8943C21.0096 7.9266 21.1073 8.02426 21.1073 8.14053V18.6072C21.1058 19.2648 20.8439 19.895 20.3788 20.3599C19.9137 20.8248 19.2833 21.0866 18.6257 21.0878H13.1008C13.0236 21.0878 12.9464 21.1464 12.9073 21.2236L12.539 22.1928C12.5252 22.2247 12.5196 22.2596 12.5227 22.2943C12.5258 22.329 12.5376 22.3623 12.5569 22.3913C12.5763 22.4202 12.6025 22.4439 12.6334 22.4601C12.6642 22.4762 12.6986 22.4844 12.7334 22.4839H18.9355C19.4043 22.4853 19.8687 22.3939 20.3021 22.2151C20.7355 22.0363 21.1292 21.7737 21.4607 21.4422C21.7922 21.1107 22.0549 20.7169 22.2337 20.2835C22.4125 19.8501 22.5038 19.3857 22.5025 18.9169V6.76395C22.5022 6.70729 22.4796 6.65302 22.4395 6.61295C22.3995 6.57288 22.3452 6.55027 22.2885 6.55002H13.0636C12.2079 6.54855 11.3602 6.71603 10.5693 7.04286C9.77847 7.3697 9.05989 7.84944 8.45482 8.4546C7.84976 9.05975 7.37011 9.7784 7.04339 10.5693C6.71668 11.3603 6.54931 12.2079 6.55091 13.0636V22.8522C6.55091 22.9099 6.57044 22.9685 6.6095 23.0066L7.57869 23.9758C7.60898 24.0061 7.64759 24.0267 7.68961 24.0349C7.73163 24.0432 7.77516 24.0388 7.81466 24.0222C7.85415 24.0056 7.88783 23.9777 7.9114 23.942C7.93497 23.9062 7.94644 23.8642 7.94609 23.8214ZM12.4237 19.3243V13.3538C12.4237 12.8507 12.8301 12.4433 13.3538 12.4433H19.3233C19.4396 12.4433 19.5372 12.54 19.5372 12.6572V18.6267C19.5372 19.1308 19.1298 19.5568 18.6257 19.5568H12.6357C12.5204 19.5382 12.4237 19.4405 12.4237 19.3243ZM18.9355 25.4296C22.5211 25.4296 25.4295 22.5025 25.4295 18.9169V9.12831C25.4308 9.0712 25.4097 9.01584 25.3709 8.97391L24.4018 8.00473C24.3714 7.97439 24.3327 7.9538 24.2906 7.94556C24.2485 7.93733 24.2049 7.94184 24.1654 7.95851C24.1258 7.97518 24.0922 8.00326 24.0687 8.03916C24.0452 8.07506 24.0329 8.11715 24.0334 8.16006V18.9364C24.0342 19.6086 23.9023 20.2743 23.6455 20.8955C23.3886 21.5166 23.0118 22.081 22.5365 22.5564C22.0613 23.0317 21.4969 23.4086 20.8758 23.6656C20.2547 23.9226 19.589 24.0546 18.9168 24.0539H11.0852C11.0287 24.0535 10.9747 24.0307 10.9348 23.9907C10.895 23.9506 10.8725 23.8965 10.8722 23.84V13.3743C10.8737 12.7167 11.1357 12.0865 11.6008 11.6215C12.0658 11.1566 12.6962 10.8949 13.3538 10.8937H18.8778C18.955 10.8937 19.0331 10.8351 19.0712 10.7579L19.4396 9.7887C19.4534 9.75682 19.459 9.722 19.4559 9.6874C19.4528 9.6528 19.4411 9.61952 19.4219 9.59059C19.4027 9.56166 19.3765 9.53799 19.3458 9.52175C19.3151 9.5055 19.2808 9.49719 19.2461 9.49757H13.0627C12.117 9.49856 11.2104 9.87471 10.5418 10.5435C9.87325 11.2122 9.49733 12.1189 9.4966 13.0646V25.2175C9.4966 25.3338 9.59333 25.4314 9.70959 25.4314H18.9364L18.9355 25.4296Z"
                    fill="#9DE747"
                />
            </g>
            <defs>
                <clipPath id="clip0_4364_18233">
                    <rect
                        width="22"
                        height="22"
                        fill="white"
                        transform="translate(5 5)"
                    />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});

export const LeapIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                d="M22.4202 8.11482C22.4135 6.3813 21.8519 4.48416 20.2953 3.54222C20.481 1.95906 19.2737 0.402425 17.7392 0.0619115C17.7392 0.0420114 17.7392 0.0199001 17.7392 0H16.1605C16.1605 0.0221112 16.1605 0.0442225 16.1605 0.0663337C16.1118 0.0751782 16.0654 0.0995006 16.0145 0.108345C15.2893 0.298502 14.6857 0.784949 14.2456 1.37753C14.2877 1.351 14.3297 1.32667 14.3805 1.29572C13.7636 1.64729 13.8852 2.6047 13.5182 3.04472C13.1202 3.11768 12.7288 3.21719 12.3374 3.30342C12.176 3.3587 12.0058 3.38744 11.8466 3.44935C10.5199 3.84736 9.22197 4.36918 8.00806 5.05242C8.02575 5.08559 8.03017 5.11875 8.02575 5.15192C8.02796 5.11875 8.02575 5.08559 8.00806 5.05242C7.15678 5.48801 6.37846 6.04521 5.59794 6.59357C4.72233 7.25912 3.90864 7.99321 3.17012 8.80912C2.87383 9.14079 2.57533 9.47909 2.31663 9.84171C1.95401 10.2707 1.64445 10.7704 1.34373 11.2391C1.1182 11.814 0.587531 12.1103 0.275762 12.6211C-0.391997 13.7377 0.167417 15.354 1.39238 15.8029C4.60735 16.2075 7.93952 15.8449 11.1943 15.9577C11.4464 15.9577 11.6984 15.9577 11.9505 15.9577C11.9549 15.951 11.9571 15.9422 11.9616 15.9334C11.9571 15.9422 11.9527 15.9488 11.9505 15.9577C12.2158 15.9577 12.4812 15.9533 12.7465 15.9577V15.9621C13.7415 15.9864 13.7105 16.0749 13.6884 15.0467C15.265 16.3734 17.3235 15.8692 19.2207 15.9444C19.6474 15.1329 19.2494 13.8018 18.449 13.2535C16.8968 12.3956 15.9482 13.2491 14.3385 11.8361C15.8155 10.9871 17.1953 9.95227 18.9023 9.67146C20.0388 9.36853 21.1753 9.06119 22.3118 8.75605C22.5396 8.67866 22.3715 8.31161 22.418 8.11482H22.4202ZM21.1908 5.95898C21.1908 5.95898 21.1687 5.95235 21.1554 5.95456C21.1687 5.95456 21.1797 5.95456 21.1908 5.95898ZM15.7448 1.26919C15.7625 1.25813 15.7779 1.24707 15.7934 1.23602C15.8576 1.20285 15.9195 1.16305 15.988 1.13873C16.0765 1.10556 16.1649 1.07018 16.2533 1.03702C16.5275 0.966261 16.8039 0.92425 17.0869 0.930883C17.0869 0.939728 17.0891 0.946361 17.0914 0.955206C17.1024 0.950783 17.1135 0.94415 17.1245 0.939728C17.1002 0.935305 17.0781 0.926461 17.0604 0.908772C17.5446 1.01048 18.0532 1.12104 18.4512 1.45492C20.9011 3.42503 17.925 7.14414 15.4684 5.21604C15.4662 5.21604 15.4595 5.21604 15.4573 5.21604C15.1522 4.93744 14.8449 4.60356 14.7255 4.19671C14.5663 3.8164 14.5375 3.37418 14.5906 2.96291C14.7188 2.2664 15.1235 1.63402 15.7426 1.27361L15.7448 1.26919ZM21.4008 7.99985C20.3594 8.26297 19.3202 8.54599 18.2832 8.82902C17.4562 9.03023 16.5563 9.25576 15.9283 9.8395C15.9372 9.82402 15.9438 9.80633 15.946 9.78643C14.7962 10.4586 13.6486 11.1286 12.5077 11.8162C13.6022 12.4132 14.5596 13.2844 15.7315 13.7045C16.6823 13.8063 18.418 13.6272 18.376 14.9848C18.3849 15.0047 18.3893 15.0224 18.4003 15.0401C18.3893 15.0224 18.3849 15.0025 18.376 14.9848C18.3583 14.9848 18.3406 14.9826 18.323 14.9804C18.323 14.9826 18.323 14.987 18.323 14.9892C17.067 14.9074 15.6829 15.2988 14.6083 14.4873C14.6105 14.5072 14.6127 14.5249 14.6149 14.5359C14.6149 14.5249 14.6105 14.505 14.6083 14.4873C14.1948 14.233 13.7791 13.9765 13.359 13.7311C12.1141 13.0368 10.2723 12.1833 11.1589 10.4741C11.1567 10.5028 11.1589 10.5316 11.1589 10.5603C11.652 9.86382 12.4082 9.49014 13.1622 9.18059C13.1224 8.98601 13.0472 8.79364 13.0008 8.60348C12.9433 8.51504 12.9676 8.29393 12.8438 8.29171C12.1097 8.51062 11.4265 8.90862 10.8693 9.43487C10.8869 9.43265 10.9024 9.42823 10.9201 9.42602C10.7874 9.4614 10.7101 9.6206 10.6039 9.70462C10.1705 9.03244 9.51163 8.54157 8.72889 8.36247C7.78474 8.22759 6.81627 8.32709 5.86548 8.30498C5.88538 8.58358 5.74829 9.07666 5.92076 9.2624C6.68139 9.2624 7.4398 9.26682 8.20043 9.27788C9.70178 9.26682 10.6172 11.2038 9.48509 12.2717C7.76263 13.5254 5.35914 12.6941 3.3647 12.9329C3.17897 12.9439 2.97997 12.9329 2.78981 12.9395C2.77875 13.2048 2.65935 13.7267 2.83845 13.8969C4.05015 13.8969 5.26185 13.9013 6.47354 13.8991C6.48902 13.9301 6.50229 13.9301 6.51776 13.8991C7.99922 13.8748 9.49836 13.9323 10.9732 13.8704C10.9732 13.8748 10.9732 13.877 10.9732 13.8814C11.7139 13.8416 12.5453 14.1954 12.6868 14.9936H12.5895V14.9981C11.6454 15.0047 10.6968 14.9914 9.75043 14.9981C8.30877 14.9826 6.86491 15.0025 5.42326 14.9848C5.42326 14.987 5.42326 14.9892 5.42326 14.9936C4.19387 14.9207 2.90921 15.1418 1.70857 14.8897C0.740098 14.5138 0.706931 13.0235 1.6555 12.5968C1.95843 12.4464 2.26135 12.2961 2.5687 12.1523C2.5687 12.1501 2.5687 12.1457 2.57091 12.1435C2.59523 12.1369 2.6085 12.1147 2.62176 12.0948C2.61292 12.1059 2.60629 12.1192 2.59744 12.1324C2.68146 12.0971 2.76549 12.0661 2.83845 12.0152C3.51064 11.6747 4.22041 11.363 4.855 10.965C4.72233 10.6797 4.57419 10.3967 4.42604 10.1203C3.85115 10.4078 3.29173 10.7217 2.70579 10.9827L2.69031 10.9672C3.48631 9.83729 4.44815 8.84007 5.48517 7.9313C6.17504 7.38515 6.87154 6.84343 7.62554 6.38794C7.61448 6.37246 7.60343 6.35477 7.59016 6.33929C7.60121 6.35477 7.61227 6.37246 7.62554 6.38794C9.1888 5.44158 10.8759 4.71412 12.6404 4.23872C12.9742 4.20998 13.3568 3.98445 13.673 4.05299C13.9118 5.04357 14.5685 5.93245 15.506 6.36583C15.5856 6.4012 15.663 6.441 15.7448 6.46975C16.5673 6.82132 17.5446 6.77709 18.3495 6.40342C18.3318 6.39015 18.3119 6.37467 18.2898 6.35698C18.3119 6.37467 18.3296 6.38794 18.3495 6.40342C18.8669 6.18009 19.2914 5.79757 19.6452 5.3664C19.8199 5.11654 19.9548 4.86447 20.0874 4.58587C20.2931 4.72738 20.4677 4.90648 20.6247 5.10327C20.8149 5.37745 20.9719 5.67153 21.1023 5.97888C21.2792 6.61568 21.5224 7.36968 21.3986 8.00869L21.4008 7.99985ZM9.52047 12.285C9.52047 12.285 9.53816 12.2784 9.547 12.2717C9.54037 12.2784 9.53153 12.285 9.52047 12.285Z"
                fill="#73C795"
            />
            <path
                d="M19.3445 3.03808C19.3445 3.03808 19.3467 3.04693 19.3489 3.04914C19.3489 3.0403 19.3489 3.03366 19.3489 3.02482C19.3489 3.02924 19.3445 3.03145 19.3445 3.03587V3.03808Z"
                fill="#73C795"
            />
            <path
                d="M16.9034 1.87061C17.1422 2.50078 17.2108 3.17739 17.1665 3.84736C17.2284 4.10827 16.8039 4.84457 17.0626 4.89543C19.0703 4.83352 18.931 1.62297 16.8946 1.78217C16.8857 1.81312 16.899 1.84187 16.9034 1.87282V1.87061Z"
                fill="#73C795"
            />
        </SvgIcon>
    );
});

export const CompanyCamIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="24"
            height="24"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            shapeRendering={'crispEdges'}
            {...rest}
        >
            <g clipPath="url(#clip0_5167_8001)">
                <mask
                    id="mask0_5167_8001"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                >
                    <path d="M32 0H0V32H32V0Z" fill="white" />
                </mask>
                <g shapeRendering={'crispEdges'} mask="url(#mask0_5167_8001)">
                    <path
                        d="M23.8944 0H8.1056C3.62899 0 0 3.62899 0 8.1056V23.8944C0 28.371 3.62899 32 8.1056 32H23.8944C28.371 32 32 28.371 32 23.8944V8.1056C32 3.62899 28.371 0 23.8944 0Z"
                        fill="url(#paint0_linear_5167_8001)"
                    />
                    <path
                        d="M10.6609 23.6272H7.09287C6.89964 23.6267 6.71447 23.5498 6.57799 23.413C6.44151 23.2762 6.36487 23.0909 6.36487 22.8976V17.4032C6.36444 17.2528 6.30442 17.1088 6.19794 17.0026C6.09146 16.8965 5.94724 16.8368 5.79687 16.8368C5.64677 16.8373 5.50296 16.897 5.39682 17.0032C5.29069 17.1093 5.23088 17.2531 5.23047 17.4032V22.8976C5.23088 23.3914 5.42724 23.8648 5.77642 24.2141C6.12559 24.5632 6.59906 24.7595 7.09287 24.76H10.6609V23.6272Z"
                        fill="white"
                    />
                    <path
                        d="M26.1969 14.128H25.5569V15.2624H25.6385V22.8976C25.638 23.091 25.5611 23.2763 25.4243 23.4131C25.2876 23.5497 25.1024 23.6267 24.9089 23.6272H21.3281V24.76H24.9089C25.4027 24.7595 25.8761 24.5632 26.2254 24.2141C26.5745 23.8648 26.7708 23.3913 26.7713 22.8976V14.6944C26.7713 14.6193 26.7564 14.545 26.7275 14.4758C26.6985 14.4065 26.6561 14.3437 26.6027 14.291C26.5492 14.2383 26.4857 14.1968 26.4161 14.1688C26.3465 14.1408 26.272 14.1269 26.1969 14.128Z"
                        fill="white"
                    />
                    <path
                        d="M15.9572 19.2448C15.5321 19.2455 15.1111 19.1624 14.7182 19C14.3253 18.8378 13.9683 18.5997 13.6676 18.2992C13.0612 17.6915 12.7207 16.868 12.7207 16.0096C12.7207 15.1511 13.0612 14.3277 13.6676 13.72C14.2753 13.1137 15.0987 12.7731 15.9572 12.7731C16.8156 12.7731 17.6391 13.1137 18.2468 13.72C18.3522 13.8264 18.4116 13.9702 18.4116 14.12C18.4116 14.2699 18.3522 14.4136 18.2468 14.52C18.1404 14.6255 17.9966 14.6848 17.8468 14.6848C17.6969 14.6848 17.5532 14.6255 17.4468 14.52C17.0519 14.1257 16.5169 13.9042 15.9588 13.9042C15.4008 13.9042 14.8656 14.1257 14.4708 14.52C14.0765 14.9148 13.855 15.45 13.855 16.008C13.855 16.5661 14.0765 17.1011 14.4708 17.496C14.866 17.8896 15.4011 18.1106 15.9588 18.1106C16.5166 18.1106 17.0516 17.8896 17.4468 17.496C17.4993 17.4434 17.5617 17.4016 17.6303 17.3731C17.699 17.3447 17.7724 17.3299 17.8468 17.3299C17.921 17.3299 17.9946 17.3447 18.0633 17.3731C18.1319 17.4016 18.1943 17.4434 18.2468 17.496C18.3522 17.6024 18.4116 17.7461 18.4116 17.896C18.4116 18.0459 18.3522 18.1896 18.2468 18.296C17.9463 18.597 17.5895 18.8359 17.1966 18.9986C16.8036 19.1615 16.3825 19.2451 15.9572 19.2448Z"
                        fill="white"
                    />
                    <path
                        d="M15.9961 26.2112C15.9041 26.211 15.8135 26.1885 15.7321 26.1456C15.6507 26.1027 15.581 26.0406 15.5289 25.9648L11.1081 19.52C10.3569 18.4261 9.99509 17.1114 10.0807 15.7871C10.1663 14.4629 10.6943 13.2058 11.5801 12.2176C12.136 11.5962 12.8165 11.099 13.5774 10.7583C14.3383 10.4175 15.1624 10.2409 15.9961 10.24C16.8294 10.2397 17.6532 10.4152 18.4138 10.7552C19.1746 11.0951 19.855 11.5918 20.4105 12.2128C21.2974 13.2 21.827 14.4566 21.914 15.7809C22.001 17.1053 21.6406 18.4203 20.8905 19.5152L16.4697 25.9648C16.417 26.0416 16.3462 26.1042 16.2636 26.147C16.181 26.1901 16.0892 26.2122 15.9961 26.2112ZM15.9961 11.3728C15.3218 11.3737 14.6553 11.5167 14.04 11.7923C13.4247 12.068 12.8744 12.4702 12.4249 12.9728C11.7072 13.7715 11.2793 14.7886 11.2099 15.8602C11.1405 16.9317 11.4338 17.9954 12.0425 18.88L15.9961 24.64L19.9481 18.88C20.5569 17.9958 20.8503 16.9325 20.7812 15.8611C20.7122 14.7899 20.2846 13.7731 19.5673 12.9744C19.118 12.4715 18.5676 12.069 17.9524 11.7931C17.337 11.5171 16.6705 11.3739 15.9961 11.3728Z"
                        fill="white"
                    />
                    <path
                        d="M24.9021 8.65598H21.4173C21.2772 8.65565 21.14 8.61506 21.0224 8.53904C20.9047 8.46302 20.8112 8.35477 20.7533 8.22718L20.1469 6.88158C19.9989 6.55528 19.7602 6.27845 19.4592 6.08411C19.1581 5.88978 18.8076 5.78614 18.4493 5.78558H13.5197C13.1668 5.78642 12.8213 5.88706 12.5232 6.0759C12.2251 6.26474 11.9865 6.53406 11.8349 6.85278L11.1821 8.23838C11.1229 8.36314 11.0295 8.46856 10.9129 8.54246C10.7962 8.61637 10.661 8.65573 10.5229 8.65598H7.09092C6.59724 8.65683 6.12402 8.85331 5.77493 9.2024C5.42585 9.55149 5.22937 10.0247 5.22852 10.5184V14.6944C5.22831 14.7689 5.24281 14.8427 5.27117 14.9116C5.29954 14.9805 5.34122 15.0432 5.39385 15.0959C5.44645 15.1487 5.50897 15.1905 5.5778 15.2191C5.64661 15.2477 5.72041 15.2624 5.79492 15.2624H6.52132V14.128H6.36132V10.5184C6.36173 10.3252 6.43879 10.14 6.57557 10.0035C6.71236 9.86704 6.89769 9.79038 7.09092 9.79038H10.5229C10.8758 9.7895 11.2212 9.68862 11.5191 9.49946C11.817 9.3103 12.0552 9.04059 12.2061 8.72158L12.8605 7.33758C12.9194 7.21242 13.0126 7.10654 13.1293 7.03232C13.246 6.9581 13.3814 6.91859 13.5197 6.91838H18.4493C18.5893 6.9191 18.7263 6.95986 18.8439 7.03584C18.9616 7.11181 19.0551 7.21984 19.1133 7.34718L19.7197 8.69438C19.8677 9.02069 20.1064 9.29752 20.4074 9.49187C20.7085 9.68621 21.0591 9.78982 21.4173 9.79038H24.9021C25.0954 9.79038 25.2807 9.86704 25.4175 10.0035C25.5543 10.14 25.6312 10.3252 25.6317 10.5184V12.2976C25.6316 12.3721 25.646 12.4459 25.6744 12.5148C25.7028 12.5837 25.7444 12.6464 25.797 12.6991C25.8496 12.7519 25.9122 12.7938 25.981 12.8223C26.0498 12.8509 26.1236 12.8656 26.1981 12.8656C26.2727 12.8656 26.3464 12.8509 26.4152 12.8223C26.484 12.7938 26.5466 12.7519 26.5992 12.6991C26.6519 12.6464 26.6935 12.5837 26.7218 12.5148C26.7503 12.4459 26.7647 12.3721 26.7645 12.2976V10.5184C26.7637 10.0247 26.5672 9.55149 26.2181 9.2024C25.869 8.85331 25.3957 8.65683 24.9021 8.65598Z"
                        fill="white"
                    />
                    <path
                        d="M11.0724 14.6944C11.0724 14.5442 11.0128 14.4001 10.9065 14.2939C10.8003 14.1877 10.6563 14.128 10.506 14.128H6.36523V15.2624H10.506C10.5805 15.2624 10.6543 15.2477 10.7232 15.2191C10.792 15.1906 10.8545 15.1487 10.9071 15.096C10.9597 15.0432 11.0014 14.9806 11.0298 14.9117C11.0581 14.8428 11.0726 14.7689 11.0724 14.6944Z"
                        fill="url(#paint1_linear_5167_8001)"
                    />
                    <path
                        d="M20.875 14.6943C20.875 14.5441 20.9347 14.4 21.0409 14.2938C21.1472 14.1876 21.2913 14.1279 21.4414 14.1279H25.5822V15.2623H21.4414C21.367 15.2623 21.2932 15.2476 21.2243 15.2191C21.1555 15.1905 21.0931 15.1486 21.0404 15.0959C20.9878 15.0431 20.946 14.9805 20.9177 14.9116C20.8894 14.8427 20.8748 14.7688 20.875 14.6943Z"
                        fill="url(#paint2_linear_5167_8001)"
                    />
                    <path
                        d="M16.6621 24.192C16.6621 24.0418 16.7218 23.8978 16.828 23.7915C16.9343 23.6853 17.0783 23.6256 17.2285 23.6256H21.3709V24.7584H17.2237C17.0744 24.7567 16.9319 24.6963 16.8267 24.5904C16.7216 24.4843 16.6626 24.3413 16.6621 24.192Z"
                        fill="url(#paint3_linear_5167_8001)"
                    />
                    <path
                        d="M15.3182 24.1952C15.3182 24.0449 15.2585 23.9009 15.1523 23.7947C15.0461 23.6885 14.902 23.6288 14.7518 23.6288H10.6094V24.7616H14.7566C14.9058 24.7598 15.0484 24.6995 15.1535 24.5936C15.2586 24.4875 15.3178 24.3445 15.3182 24.1952Z"
                        fill="url(#paint4_linear_5167_8001)"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_5167_8001"
                    x1="6.0704"
                    y1="3.4304"
                    x2="18.7104"
                    y2="19.4304"
                    gradientUnits="userSpaceOnUse"
                    shapeRendering={'crispEdges'}
                >
                    <stop stopColor="#3A85DB" />
                    <stop offset="1" stopColor="#0967D2" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_5167_8001"
                    x1="6.36043"
                    y1="14.6944"
                    x2="11.0676"
                    y2="14.6944"
                    gradientUnits="userSpaceOnUse"
                    shapeRendering={'crispEdges'}
                >
                    <stop offset="0.1" stopColor="white" />
                    <stop offset="0.85" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_5167_8001"
                    x1="25.587"
                    y1="14.6943"
                    x2="20.8798"
                    y2="14.6943"
                    gradientUnits="userSpaceOnUse"
                    shapeRendering={'crispEdges'}
                >
                    <stop offset="0.1" stopColor="white" />
                    <stop offset="0.85" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_5167_8001"
                    x1="21.3285"
                    y1="24.1936"
                    x2="16.6197"
                    y2="24.1936"
                    gradientUnits="userSpaceOnUse"
                    shapeRendering={'crispEdges'}
                >
                    <stop stopColor="white" />
                    <stop offset="0.85" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_5167_8001"
                    x1="10.6614"
                    y1="24.1936"
                    x2="15.3702"
                    y2="24.1936"
                    gradientUnits="userSpaceOnUse"
                    shapeRendering={'crispEdges'}
                >
                    <stop stopColor="white" />
                    <stop offset="0.85" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <clipPath id="clip0_5167_8001">
                    <rect
                        shapeRendering={'crispEdges'}
                        width="32"
                        height="32"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});

export const InstagramIcon = forwardRef<SVGSVGElement, SvgIconProps>(
    (props, ref) => (
        <SvgIcon
            ref={ref}
            viewBox="0 0 132 132"
            width={24}
            height={24}
            {...props}
        >
            <defs>
                <linearGradient id="b">
                    <stop offset="0" stopColor="#3771c8" />
                    <stop offset=".128" stopColor="#3771c8" />
                    <stop offset="1" stopColor="#60f" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="a">
                    <stop offset="0" stopColor="#fd5" />
                    <stop offset=".1" stopColor="#fd5" />
                    <stop offset=".5" stopColor="#ff543e" />
                    <stop offset="1" stopColor="#c837ab" />
                </linearGradient>
                <radialGradient
                    id="c"
                    cx="158.429"
                    cy="578.088"
                    r="65"
                    xlinkHref="#a"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(0 -1.98198 1.8439 0 -1031.402 454.004)"
                    fx="158.429"
                    fy="578.088"
                />
                <radialGradient
                    id="d"
                    cx="147.694"
                    cy="473.455"
                    r="65"
                    xlinkHref="#b"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(.17394 .86872 -3.5818 .71718 1648.348 -458.493)"
                    fx="147.694"
                    fy="473.455"
                />
            </defs>

            <path
                fill="url(#c)"
                d="M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z"
                transform="translate(1.004 1)"
            />
            <path
                fill="url(#d)"
                d="M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z"
                transform="translate(1.004 1)"
            />
            <path
                fill="#fff"
                d="M66.004 18c-13.036 0-14.672.057-19.792.29-5.11.234-8.598 1.043-11.65 2.23-3.157 1.226-5.835 2.866-8.503 5.535-2.67 2.668-4.31 5.346-5.54 8.502-1.19 3.053-2 6.542-2.23 11.65C18.06 51.327 18 52.964 18 66s.058 14.667.29 19.787c.235 5.11 1.044 8.598 2.23 11.65 1.227 3.157 2.867 5.835 5.536 8.503 2.667 2.67 5.345 4.314 8.5 5.54 3.054 1.187 6.543 1.996 11.652 2.23 5.12.233 6.755.29 19.79.29 13.037 0 14.668-.057 19.788-.29 5.11-.234 8.602-1.043 11.656-2.23 3.156-1.226 5.83-2.87 8.497-5.54 2.67-2.668 4.31-5.346 5.54-8.502 1.18-3.053 1.99-6.542 2.23-11.65.23-5.12.29-6.752.29-19.788 0-13.036-.06-14.672-.29-19.792-.24-5.11-1.05-8.598-2.23-11.65-1.23-3.157-2.87-5.835-5.54-8.503-2.67-2.67-5.34-4.31-8.5-5.535-3.06-1.187-6.55-1.996-11.66-2.23-5.12-.233-6.75-.29-19.79-.29zm-4.306 8.65c1.278-.002 2.704 0 4.306 0 12.816 0 14.335.046 19.396.276 4.68.214 7.22.996 8.912 1.653 2.24.87 3.837 1.91 5.516 3.59 1.68 1.68 2.72 3.28 3.592 5.52.657 1.69 1.44 4.23 1.653 8.91.23 5.06.28 6.58.28 19.39s-.05 14.33-.28 19.39c-.214 4.68-.996 7.22-1.653 8.91-.87 2.24-1.912 3.835-3.592 5.514-1.68 1.68-3.275 2.72-5.516 3.59-1.69.66-4.232 1.44-8.912 1.654-5.06.23-6.58.28-19.396.28-12.817 0-14.336-.05-19.396-.28-4.68-.216-7.22-.998-8.913-1.655-2.24-.87-3.84-1.91-5.52-3.59-1.68-1.68-2.72-3.276-3.592-5.517-.657-1.69-1.44-4.23-1.653-8.91-.23-5.06-.276-6.58-.276-19.398s.046-14.33.276-19.39c.214-4.68.996-7.22 1.653-8.912.87-2.24 1.912-3.84 3.592-5.52 1.68-1.68 3.28-2.72 5.52-3.592 1.692-.66 4.233-1.44 8.913-1.655 4.428-.2 6.144-.26 15.09-.27zm29.928 7.97c-3.18 0-5.76 2.577-5.76 5.758 0 3.18 2.58 5.76 5.76 5.76 3.18 0 5.76-2.58 5.76-5.76 0-3.18-2.58-5.76-5.76-5.76zm-25.622 6.73c-13.613 0-24.65 11.037-24.65 24.65 0 13.613 11.037 24.645 24.65 24.645C79.617 90.645 90.65 79.613 90.65 66S79.616 41.35 66.003 41.35zm0 8.65c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z"
            />
        </SvgIcon>
    )
);
